import script from "./ViewEmployees.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewEmployees.vue?vue&type=script&setup=true&lang=js"

import "./ViewEmployees.vue?vue&type=style&index=0&id=922a296a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-922a296a"]])

export default __exports__